<script setup>
import { computed, inject, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

import OverviewLineChart from '@/components/overview/OverviewLineChart.vue'

const store = useStore()

const appHeaderHeight = inject('appHeaderHeight')

const ignoreHeight = computed(() => {
  return (appHeaderHeight?.value ?? 0) + 'px'
})

const loadingSoilType = computed(() => store.state.baseSoilType.loading)

const getSchemaLoadingById = (id) => store.getters['stabSchematisationStage/getLoadingById'](id)

const getLoadingById = (id) => store.getters['overview/getLoadingById'](id)

const currentStabSchematisationStage = computed(() =>
  getStabSchematisationStageById(selectedStabSchematisationStageId.value)
)

const selectedProjectId = computed(() => store.getters['project/selectedProjectId'])

const getStabSchematisationStageById = (id) =>
  store.getters['stabSchematisationStage/getStabSchematisationStageById'](id)
const fetchStabSchematisationOverview = (id) =>
  store.dispatch('stabSchematisationStage/fetchItemOverview', id)
const fetchBaseSoilTypeItems = (id) => store.dispatch('baseSoilType/fetchItems', id)
const fetchOverviewData = (stage) => store.dispatch('overview/fetchOverviewData', stage)

const loading = computed(() => {
  if (selectedStabSchematisationStageId.value) {
    return (
      loadingSoilType.value ||
      getSchemaLoadingById(selectedStabSchematisationStageId.value) ||
      getLoadingById(selectedStabSchematisationStageId.value)
    )
  }
  return false
})

const selectedStabSchematisationStageId = computed(
  () => store.state.dikeProfiles.selectedStabSchematisationStageId
)

const fetchRelatedData = async () => {
  if (selectedStabSchematisationStageId.value) {
    await fetchStabSchematisationOverview(selectedStabSchematisationStageId.value)
    await fetchOverviewData(getStabSchematisationStageById(selectedStabSchematisationStageId.value))
  }
}

watch(selectedStabSchematisationStageId, async () => {
  await fetchRelatedData()
})
onMounted(async () => {
  await fetchBaseSoilTypeItems(selectedProjectId.value)
  await fetchRelatedData()
})
</script>

<template>
  <v-card variant="flat">
    <v-alert
      v-if="!selectedStabSchematisationStageId"
      class="ma-3"
      type="info"
      variant="tonal"
      density="compact"
    >
      Select a
      <span style="font-weight: bold">
        Schematisation row that has at least one completed stage
      </span>
      to see the overview data.
    </v-alert>

    <template v-else>
      <v-progress-linear
        color="primary"
        v-if="loading || !currentStabSchematisationStage"
        indeterminate
      />

      <v-lazy v-else>
        <OverviewLineChart
          :stab-schematisation-stage="currentStabSchematisationStage"
          ref-prefix="side-bar"
          :ignore-height="ignoreHeight"
        />
      </v-lazy>
    </template>
  </v-card>
</template>
